(function(app, ng) {

    app.component("support",
        {
            templateUrl: "/App/Home/Components/Support/support-template.html",
            controller: supportController
        });

    supportController.$inject = [];
    function supportController() {
        var $ctrl = this;

        ng.extend($ctrl,
            {
            });
    }

})(window.app, window.angular); //jshint: ignore line